import methods from "../Service";
import useHttpParamsJsonCreate from "hooks/useHttpParamsJsonCreate";
const useParamsJson = (param) => { return useHttpParamsJsonCreate(param); }
const AmbientePuntoEmision = {
    
    async Get() { return await methods.Get("AmbientePuntoEmision/Get" ) },
    async Post(data) { return await methods.Post("AmbientePuntoEmision/Post", data) },
    async Put(qs, data) { return await methods.Put("AmbientePuntoEmision/Put" + useParamsJson(qs), data) },
    async Delete(qs) { return await methods.Delete("AmbientePuntoEmision/Delete" + useParamsJson(qs)) }
};

export default AmbientePuntoEmision;